import * as utils from '@net0-calc/common/utils';
import { i18n } from 'services';

export const isEmail = (value: string) => (utils.isEmail(value) ? undefined : i18n.t('Input correct email address'));
